// X-PRO5 funnel: apre il popup extra e manda al checkout con un cart permalink
// (/cart/VARIANTE:1,VARIANTE:1 sostituisce il carrello e apre il checkout Shopify).
const x5Root = () => window.Shopify?.routes?.root || '/';

// Sorgente del traffico salvata negli attributi del carrello: i cookie analytics di
// Shopify (_landing_page, _orig_referrer) si bloccano senza consenso e l'ordine resta
// senza referrer, il carrello invece e' tecnico e passa sempre.
const X5_KEY = 'x5_source';
const x5Source = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach((key) => {
      if (q.get(key)) found[key] = q.get(key);
    });
    if (document.referrer && !document.referrer.includes(window.location.host)) {
      found.referrer = new URL(document.referrer).host;
    }
    if (Object.keys(found).length) sessionStorage.setItem(X5_KEY, JSON.stringify(found));
    return JSON.parse(sessionStorage.getItem(X5_KEY) || '{}');
  } catch (error) {
    return {};
  }
};

// Scritta subito: copre anche chi compra dalla pagina prodotto senza passare dal popup.
const x5Attributes = x5Source();
if (Object.keys(x5Attributes).length) {
  fetch(`${x5Root()}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: x5Attributes }),
  }).catch(() => {});
}

// ViewContent sulla landing: Shopify lo manda solo dalle pagine prodotto, qui la
// scheda e' dentro una sezione custom e l'evento non parte mai (verificato: dalla
// home esce solo PageView). fbq compare solo dopo il consenso cookie, quindi
// aspettarlo fa anche da gate privacy.
const x5ViewContent = () => {
  const dialog = document.getElementById('x5-addons');
  if (!dialog || !dialog.dataset.kit) return;
  let attempts = 0;
  const timer = setInterval(() => {
    if (typeof window.fbq === 'function' && window.fbq.loaded) {
      clearInterval(timer);
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_ids: [dialog.dataset.kit],
        content_name: dialog.dataset.title || '',
        value: parseFloat(dialog.dataset.price || '0'),
        currency: dialog.dataset.currency || 'EUR',
      });
    } else if (++attempts > 40) {
      clearInterval(timer);
    }
  }, 500);
};
x5ViewContent();

document.addEventListener('click', (event) => {
  const dialog = document.getElementById('x5-addons');
  if (!dialog) return;

  if (event.target.closest('[data-x5-buy]')) {
    event.preventDefault();
    dialog.showModal();
    return;
  }
  if (event.target === dialog || event.target.closest('[data-x5-close]')) {
    dialog.close();
    return;
  }

  const go = event.target.closest('[data-x5-go]');
  if (!go) return;
  const ids = [dialog.dataset.kit];
  const names = [];
  if (!go.hasAttribute('data-x5-skip')) {
    dialog.querySelectorAll('input[name="addon"]:checked').forEach((input) => {
      ids.push(input.value);
      names.push(input.dataset.x5Name);
    });
  }
  // Aggiunta vera al carrello invece del permalink: cosi' Shopify pubblica
  // product_added_to_cart al click e l'app Facebook manda AddToCart (browser +
  // server, deduplicati). Col permalink l'evento usciva solo dal checkout.
  const root = x5Root();
  const attributes = Object.assign({ upsell: names.join(', ') || 'nessuno' }, x5Attributes);
  const post = (path, data) =>
    fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) throw new Error(path);
      return response;
    });

  // Il permalink resta come rete di sicurezza: se una chiamata fallisce il
  // cliente arriva comunque al checkout con gli stessi articoli.
  const permalink = () => {
    const params = new URLSearchParams();
    Object.entries(attributes).forEach(([key, value]) => params.set(`attributes[${key}]`, value));
    window.location.href = `${root}cart/${ids.map((id) => `${id}:1`).join(',')}?${params}`;
  };

  go.disabled = true;
  post('cart/clear.js', {})
    .then(() => post('cart/add.js', { items: ids.map((id) => ({ id: id, quantity: 1 })) }))
    .then(() => post('cart/update.js', { attributes }))
    .then(() => {
      window.location.href = `${root}checkout`;
    })
    .catch(permalink);
});
